import React from 'react';
import { Route, Switch, useRouteMatch  } from "react-router-dom";
import { Container } from 'react-bootstrap'

import CuentasList from "./cuentas/CuentasList";
import AddCuenta from "./cuentas/AddCuenta";

import '../../styles/catalogos/catalogos.css'
import FieldsCuenta from './cuentas/FieldsCuenta';
import ConfCuenta from './cuentas/ConfCuenta';

function CuentasIndex(){
    const { path, url } = useRouteMatch();

    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={ path }><CuentasList url={ url }/></Route>
                <Route exact path={`${path}/create`}><AddCuenta /></Route>
                <Route exact path={`${path}/fields/:id`}><FieldsCuenta /></Route>
                <Route exact path={`${path}/conf/:id`}><ConfCuenta /></Route>
            </Switch>
        </Container>
    )
}

export default CuentasIndex